<template>
  <div class="container"><h1>預計為首頁的頁面</h1></div>
</template>

<script>
// export default {
//   name: "HelloWorld",
//   props: {
//     msg: String,
//   },
// };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
